// extracted by mini-css-extract-plugin
export default {"add_del":"AddAndDeleteOption_add_del__7oyDK","th":"AddAndDeleteOption_th__Ctla2","td":"AddAndDeleteOption_td__Ntzb2","td__wrapper":"AddAndDeleteOption_td__wrapper__7YGWk"};